import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsScikitLearnComponent } from './simple-icons-scikit-learn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsScikitLearnComponent ],
    exports:      [ SimpleIconsScikitLearnComponent ],
    bootstrap:    []
})
export class SimpleIconsScikitLearnModule {}
